/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;

      if ( document.querySelector( '.social-share__link.share-link' ) ) {
        const copyButton = document.querySelector( '.social-share__link.share-link' );

        copyButton.addEventListener( 'click', () => {
          /* Please ensure you are on https for this to work */
          navigator.clipboard.writeText( copyButton.dataset.url )
              .then( () => {
                const copied = copyButton.parentElement.querySelector( '.copied-text' );

                copied.classList.add( 'is-copied' );

                setTimeout( function() {
                  copied.classList.remove( 'is-copied' );
                }, 2000 );
              } )
              .catch( () => {
                console.log( 'Failed to copy text.' );
              } );
        } );
      }
      if ( document.querySelector( '.blog-page' ) ) {
        const bgColor = [
          'brand-blue',
          'brand-green',
          'brand-orange',
        ];
        let currentBgColorKey = 0;
        $( '.post__card' ).each( function() {
          $( this ).find( '.blog-card__circle' ).addClass( 'bg-'+bgColor[currentBgColorKey] );
          $( this ).find( 'svg.icon' ).addClass( 'text-'+bgColor[currentBgColorKey] );
          if ( currentBgColorKey === 2 ) {
            currentBgColorKey = 0;
          } else {
            currentBgColorKey ++;
          }
        } );
      }

      // $( document ).on( 'click', '.blog__filters a', function( e ) {
      //   e.preventDefault();
      //   const url = $( this ).attr( 'href' );
      //   if ( !url ) return;

      //   // const isLoadMore = $( this ).hasClass( 'load-more' );
      //   $.ajax( {
      //     type: 'GET',
      //     url: url,
      //     beforeSend: function( xhr ) {
      //     },
      //     success: function( data ) {
      //       const componentHTML = $( data ).find( '.blog__posts-grid' );

      //       const currentDOM = $( document ).find( '.blog__posts-grid' );
      //       nextPage = componentHTML.data( 'next-page' );
      //       console.log( nextPage );
      //       // currentDOM.find( '.category-toggle' ).html( componentHTML.find( '.category-toggle' ).html() );
      //       // if ( isLoadMore ) {
      //       //   const newItems = componentHTML.find( '.gallery-item' );
      //       //   currentDOM.find( '.gallery-items' ).append( newItems );
      //       //   console.log( nextPage );
      //       //   if ( nextPage && nextPage <= maxPages ) {
      //       //     currentDOM.find( '.load-more' ).attr( 'href', componentHTML.find( '.load-more' ).attr( 'href' ) );
      //       //   } else {
      //       //     currentDOM.find( '.load-more' ).remove();
      //       //   }
      //       // } else {
      //       currentDOM.html( componentHTML.html() );
      //       // }

      //       // app.components.animations.init();
      //     },
      //     complete: function( jqXHR, status ) {
      //     },
      //   } );
      // } );
    },

    finalize: function() {
    },
  };

  app.registerComponent( 'blog', COMPONENT );
} )( app );
